// Stepper label for the synthetic robot step (sc-29236). Non-breaking space:
// every other label is one word, and a two-word label wraps under the icon on
// a phone-width stepper.
const ROBOT_STEP_LABEL = 'With\u00a0robot'

const externalStatus: { [key: string]: string } = {
  at_depot: 'Collected',
  cancelled: 'Cancelled',
  collected: 'Collected',
  delivery_complete: 'Delivered',
  delivery_failed: 'Attempted',
  in_transit: 'In Transit',
  out_for_collection: 'Packed',
  out_for_delivery: 'Delivering',
  on_hold: 'On Hold',
  pending: 'Packed',
  ready_for_collection: 'Packed',
  received_at_depot: 'Collected',
  return_to_origin: 'Cancelled',
  returned_to_origin: 'Cancelled',
  scheduled: 'Scheduled',
  // Synthetic stepper-only step for the Nabd robot leg (sc-29236). Never a
  // real order state: `withRobotStep` in lib/robot-delivery.ts inserts it into
  // the stepper's list from `robotDelivery.loadedAt`; the order itself stays
  // out_for_delivery ("Delivering") for the whole indoor leg.
  robot_loaded: ROBOT_STEP_LABEL,
}

// When several internal states map to the same external label, the canonical
// state owns the date for that label. Without this, dedup falls back to the
// most recent matching state change — which for "Collected" picks a later
// `at_depot` over the actual `collected` event (sc-26000). Only labels with
// reported incidents are listed; other labels keep the existing "most-recent
// match" semantics so unrelated UX doesn't shift silently.
const canonicalStateForLabel: { [label: string]: string } = {
  Collected: 'collected',
}

export { externalStatus, canonicalStateForLabel, ROBOT_STEP_LABEL }
